export default "__VITE_ASSET__ec0b78d0__"